import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

// Components
import Badge from "components/Badge";
import {FormattedMessage} from "react-intl";
import {Grid} from "@mui/material";

WmsItemPlaceList.propTypes = {
    wmsItem: PropTypes.shape({
        places: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string.isRequired
            })
        )
    })
};

function WmsItemPlaceList({wmsItem}) {
    const [hasWmsPlace, setHasWmsPlace] = useState(true)

    if (!wmsItem) {
        return null;
    }

    useEffect(() => {
        if (0 === wmsItem.places.length) {
            setHasWmsPlace(false)
        }
    }, [wmsItem]);
    return (
        <Grid
            container
            direction={'row'}
            flexWrap={'nowrap'}
            gap={'8px'}
            sx={{overflow: 'auto'}}
        >
            {!hasWmsPlace && (
                <Badge
                    style={{cursor: "loading"}}
                    key={0}
                    label={<FormattedMessage id={"wms.myPickingMission.toggle.noZone"}/>}
                    isBold={false}
                    size={"large"}
                />
            )}

            {hasWmsPlace && wmsItem.places.map((place, index) => (
                <Badge
                    style={{cursor: "loading"}}
                    key={index}
                    label={place.name}
                    isBold={false}
                    size={"large"}
                />
            ))}
        </Grid>
    );
}

export default WmsItemPlaceList;
